<div
  id="adyen-container"
  class="adyen-container">
  <div>
    @if (showBackButton()) {
      <slotcom-navigation-button
        type="close"
        width="4"
        height="4"
        data-testid="close-adyen-button"
        topPosition="0"
        rightPosition="-6"
        (click)="goBack()">
      </slotcom-navigation-button>
    }

    <div
      id="dropin-container"
      class="adyen-dropin-container"></div>
  </div>
</div>
